import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, ListItemButton, ListItemSecondaryAction, ListItemText, } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
export function ListItemElement(props) {
    const { primary, secondary, show, ...rest } = props;
    if (!show) {
        return null;
    }
    return (_jsxs(ListItemButton, { ...rest, children: [_jsx(ListItemText, { primary: primary, secondary: secondary }), _jsx(ListItemSecondaryAction, { children: _jsx(IconButton, { size: "large", children: _jsx(ChevronRight, {}) }) })] }));
}
